// root
export const SET_PAGE_STATE_ROOT = 'SET_PAGE_STATE_ROOT'
// code的设置与保存
export const SAVE_CODE = 'SAVE_CODE'

// token的设置与保存
export const GET_TOKEN = 'GET_TOKEN'
export const SAVE_TOKEN = 'SAVE_TOKEN'

// 用户信息的设置与保存
export const GET_USER = 'GET_USER'
export const SAVE_USER = 'SAVE_USER'

// 所有返回的请求指标类型与请求接口标志 像191
export const SAVE_TYPE_ALL_LIST = 'SAVE_TYPE_ALL_LIST'

// 日 月 类型的切换
export const SAVE_TAB_ACTIVE_TYPE = 'SAVE_TAB_ACTIVE_TYPE'
// 日 月 值
export const SAVE_ACTIVE_DATE = 'SAVE_ACTIVE_DATE'
// 展示当前请求有数据的最新日期
export const SAVE_SHOW_SELECT_DATE_VALUE = 'SAVE_SHOW_SELECT_DATE_VALUE'

// 用户个人所在地区信息，及下面的地区
export const EGT_USER_AREAS = 'EGT_USER_AREAS'
export const SAVE_USER_AREAS = 'SAVE_USER_AREAS'
// 选择的地区
export const SAVE_SELECT_AREA = 'SAVE_SELECT_AREA'

// 保留城市选择器
export const SAVE_MEAL_MODEL = 'SAVE_MEAL_MODEL'

// 保存日期
export const SAVE_MEAL_DATE = 'SAVE_MEAL_DATE'

// 保存收藏的指标类型数据
export const SAVE_COLLECT_DATA = 'SAVE_COLLECT_DATA'

export const SAVE_MEAL_FIRST_AREAS = 'SAVE_MEAL_FIRST_AREAS'

export const SAVE_MEAL_DEPART_OBJECT = 'SAVE_MEAL_DEPART_OBJECT'

export const SAVE_MEAL_XID = 'SAVE_MEAL_XID'



// WEBPACK FOOTER //
// ./src/store/app/types.js